import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle, Heading } from '../../components';
import { FaBook, FaCheck, FaEnvelope, FaGlobe } from 'react-icons/fa';
import './BibliotekaOgrodnicza.css';

const BibliotekaOgrodnicza = () => {
    const { t } = useTranslation();

    const collectionsList = t('library.collectionsList', { returnObjects: true }) || [];
    const supportPoints = t('library.supportPoints', { returnObjects: true }) || [];

    return (
        <div className="library-page-wrapper">
            <PageTitle 
                title={t('library.pageTitle')} 
                page={t('library.pageBreadcrumb')} 
            />

            <section className="library-section page-single">
                <div className="page-info">
                    <div className="content">
                        <Heading 
                            title={t('library.headingTitle')} 
                            subTitle={t('library.headingSubtitle')} 
                            sideHeading 
                        />

                        <p className="library-lead">
                            {t('library.lead')}
                        </p>

                        <p>
                            {t('library.ambition')}
                        </p>

                        <div className="sub-section">
                            <h3 className="sub-heading">{t('library.differentHeading')}</h3>
                            <p>
                                {t('library.differentDescription')}
                            </p>
                            <ul className="library-list">
                                {Array.isArray(collectionsList) && collectionsList.map((item, idx) => (
                                    <li key={idx}>
                                        <FaCheck className="icon green-icon" /> {item}
                                    </li>
                                ))}
                            </ul>
                            <p style={{ marginTop: '1.5rem' }}>
                                {t('library.specialMeaning')}
                            </p>
                        </div>

                        <div className="sub-section highlight-box">
                            <h3 className="sub-heading">
                                <FaBook className="icon-header" /> {t('library.cabinetTitle')}
                            </h3>
                            <p>
                                {t('library.cabinetDescription')}
                            </p>
                        </div>

                        <div className="sub-section">
                            <h3 className="sub-heading">{t('library.botanicalBackgroundTitle')}</h3>
                            <p>{t('library.botanicalBackgroundIntro')}</p>
                            <ul className="library-list">
                                {Array.isArray(supportPoints) && supportPoints.map((item, idx) => (
                                    <li key={idx}>
                                        <FaCheck className="icon green-icon" /> {item}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="sub-section">
                            <h3 className="sub-heading">{t('library.donateHeading')}</h3>
                            <p>
                                {t('library.donateDescription')}
                            </p>
                            <div className="library-contact-box">
                                <p>
                                    <FaGlobe className="icon" />{' '}
                                    <a href="https://www.dworimielno.com" target="_blank" rel="noreferrer">
                                        www.dworimielno.com
                                    </a>
                                </p>
                                <p>
                                    <FaEnvelope className="icon" />{' '}
                                    <a href="mailto:info@dworimielno.com">
                                        info@dworimielno.com
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BibliotekaOgrodnicza;